<template>
	<div>
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="p-6 py-5 flex center">
			<div style="width: 500px;">
				<div class="pos-re">
					<div class="beforeBecomeTeacher-head-img">

					</div>
					<div class="beforeBecomeTeacher-head-content p-3">
						<div class="cl-w">
							{{$t('becomeTeacher.miraTeacher')}}
						</div>
						<div class="cl-w mt-2 ftr-1-25 ftw600">
							{{$t('becomeTeacher.continueTeacher')}}
						</div>
						<div class="flex center" style="margin-top: 106px;">
							<div class="btn btn-theme" style="width: 120px;" @click="toBecome()">
								{{$t('becomeTeacher.applyNow')}}
							</div>
						</div>

					</div>
				</div>
				<div class="mt-2 flex around">
					<div class="beforeBecomeTeacher-head-bottom-item border-gray">
						<div></div>
						<div>
							<div class="cl-theme ftw600 ft16">
								{{$t('becomeTeacher.idealIncome')}}?
							</div>
							<div class="mt-4 btn btn-outline-theme" style="width: 100px;" @click="showModal1 = true">
								{{$t('becomeTeacher.details')}}
							</div>
						</div>
					</div>
					<div class="beforeBecomeTeacher-head-bottom-item border-gray">
						<div></div>
						<div>
							<div class="cl-theme ftw600 ft16">
								{{$t('becomeTeacher.restriction')}}?
							</div>
							<div class="mt-4 btn btn-outline-theme" style="width: 100px;" @click="showModal2 = true">
								{{$t('becomeTeacher.details')}}
							</div>
						</div>
					</div>
					<div class="beforeBecomeTeacher-head-bottom-item border-gray">
						<div></div>
						<div>
							<div class="cl-theme ftw600 ft16">
								{{$t('becomeTeacher.recommendedPlan')}}
							</div>
							<div class="cl-theme ftw600 ft16">
								=
							</div>
							<div class="cl-theme ftw600 ft16">
								{{$t('becomeTeacher.increaseIncome')}}?
							</div>
							<div class="mt-3 btn btn-outline-theme" style="width: 100px;" @click="showModal3 = true">
								{{$t('becomeTeacher.details')}}
							</div>
						</div>
					</div>
				</div>
				<div class="mt-4">
					<div class="ftw600 ftr-1-25">
						{{$t('becomeTeacher.applicationProcess')}}
					</div>
					<div class="border-gray p-3 flex space alcenter mt-3">
						<div>
							<div class="cl-theme ftw600 ftr-1-25">
								1. {{$t('becomeTeacher.applicationProcessOne1')}}
							</div>
							<div class="mt-2">
								{{$t('becomeTeacher.applicationProcessOne2')}}
							</div>
							<div class="">
								{{$t('becomeTeacher.applicationProcessOne3')}}
							</div>
						</div>
						<img src="../../assets/image/teacher/become1.png" alt="" class="photo-50" />
					</div>
					
					<div class="border-gray p-3 flex space alcenter mt-3">
						<div>
							<div class="cl-theme ftw600 ftr-1-25">
								2. {{$t('becomeTeacher.applicationProcessTwo1')}}
							</div>
							<div class="mt-2">
								{{$t('becomeTeacher.applicationProcessTwo2')}}
							</div>
							<div class="">
								{{$t('becomeTeacher.applicationProcessTwo3')}}
							</div>
						</div>
						<img src="../../assets/image/teacher/become2.png" alt="" class="photo-50" />
					</div>
					<div class="border-gray p-3 flex space alcenter mt-3">
						<div>
							<div class="cl-theme ftw600 ftr-1-25">
								3. {{$t('becomeTeacher.applicationProcessThree1')}}
							</div>
							<div class="mt-2">
								{{$t('becomeTeacher.applicationProcessThree2')}}
							</div>
							<div class="">
								{{$t('becomeTeacher.applicationProcessThree3')}}
							</div>
						</div>
						<img src="../../assets/image/teacher/become3.png" alt="" class="photo-50" />
					</div>
					<div class="border-gray p-3 flex space alcenter mt-3">
						<div>
							<div class="cl-theme ftw600 ftr-1-25">
								4. {{$t('becomeTeacher.applicationProcessFour1')}}
							</div>
							<div class="mt-2">
								{{$t('becomeTeacher.applicationProcessFour2')}}
							</div>
							<div class="">
								{{$t('becomeTeacher.applicationProcessFour3')}}
							</div>
						</div>
						<img src="../../assets/image/teacher/become4.png" alt="" class="photo-50" />
					</div>
				</div>
				<div class="flex ftr-1-25 cl-black mt-4">
					{{$t('common.askedQuestions')}}
				</div>
				<div class="mt-3" style="width: 100%;">
					<a-collapse v-model:activeKey="activeKey" style="width: 100%;" >
					   <a-collapse-panel :key="String(index) " :header="item.name " v-for="(item,index) in questionsList">
					     <p>{{ item.description }}</p>
					   </a-collapse-panel>
					 </a-collapse>
				</div>
			</div>
		</div>
		<a-modal :title="null" v-model="showModal1" :footer="null" @cancel="showModal1=false">
			<div>
				<div class="text-center cl-theme ftr-1-25 ftw600 border-b pb-3 wid-100">
					{{$t('becomeTeacher.idealIncome')}}?
				</div>
				<div class="ftw600 cl-black mt-3">
					{{$t('becomeTeacher.modalOne1')}}
				</div>
				<div class="">
					{{$t('becomeTeacher.modalOne2')}}
					(<span class="cl-theme">{{$t('becomeTeacher.modalOne3')}}</span>)
				</div>
				<div class="ftw600 cl-black mt-3">
					{{$t('becomeTeacher.modalOne4')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalOne5')}}
				</div>
				<div class="text-underline cl-black mt-3">
					{{$t('becomeTeacher.modalOne6')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalOne7')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalOne10')}}
				</div>
				<div class="ftw600 cl-black mt-3">
					{{$t('becomeTeacher.modalOne8')}}
				</div>
				<div class="cl-theme ftw600 ftr-1-25">
					{{$t('becomeTeacher.modalOne9')}}
				</div>
				<div style="height: 100px;"></div>
			</div>
		</a-modal>

		<a-modal :title="null" v-model="showModal2" :footer="null" @cancel="showModal2=false">
			<div>
				<div class="text-center cl-theme ftr-1-25 ftw600 border-b pb-3 wid-100">
					{{$t('becomeTeacher.restriction')}}?
				</div>
				<div class="ftw600 mt-3 cl-black">
					{{$t('becomeTeacher.modalTwo1')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalTwo2')}}
				</div>
				<div class="ftw600 mt-3 cl-black">
					{{$t('becomeTeacher.modalTwo3')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalTwo4')}}
				</div>
				<div style="height: 200px;"></div>
				<div>
					{{$t('becomeTeacher.modalTwo5')}}
				</div>
			</div>
		</a-modal>
		
		<a-modal :title="null" v-model="showModal3" :footer="null" @cancel="showModal3=false">
			<div>
				<div class="text-center cl-theme ftr-1-25 ftw600 border-b pb-3 wid-100">
					{{$t('becomeTeacher.recommendedPlan')}} =
					{{$t('becomeTeacher.increaseIncome')}}?
				</div>
				<div class="ftw600 mt-3 cl-black">
					{{$t('becomeTeacher.modalThree1')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalThree2')}}
					(<span class="cl-theme">{{$t('becomeTeacher.modalThree3')}}</span>)
				</div>
				<div class="ftw600 mt-3 cl-black">
					{{$t('becomeTeacher.modalThree4')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalThree5')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalThree6')}}
				</div>
				<div class="ftw600 mt-3 cl-theme">
					{{$t('becomeTeacher.modalThree7')}}
				</div>
				<div class="ftw600 mt-3 cl-black">
					{{$t('becomeTeacher.modalThree8')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalThree9')}}
				</div>
				<div>
					{{$t('becomeTeacher.modalThree10')}}
				</div>
				<div class="ftw600 mt-3 cl-theme">
					{{$t('becomeTeacher.modalThree11')}}
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showModal1: false,
				showModal2: false,
				showModal3: false,
				showModal4: false,
				activeKey:[],
				questionsList:[]
			}
		},
		created() {
			this.getCategory()
		},
		methods: {
			toBecome(){
				if(!this.checkLogin()){
					this.$router.push('/login');
					return
				}
				this.$router.push('/becomeTeacher');
			},
			getCategory(){
				this.$http.api('index/category',{
					pid:23
				}).then(res=>{
					console.log("res",res);
					this.questionsList = res.list
				})
			},
		}
	}
</script>

<style>
	::v-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header{
		color: #52C4C9 !important;
		font-size: 1.25rem;
	}
	.photo-50{
		width: 60px;
		height: 60px;
	}
	.beforeBecomeTeacher-head-img {
		width: 100%;
		height: 248px;
		background-color: rgba(82, 196, 201, 0.4);
		position: relative;
	}

	.beforeBecomeTeacher-head-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
	}

	.beforeBecomeTeacher-head-bottom-item {
		width: 32%;
		height: 200px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 16px;
		text-align: center;
	}
</style>